import SettingsRoutes from "./settings"
import ProductionRoutes from "./production"
import IntakeRoutes from "./intake"
import FinanceRoutes from "./finance"
import QualityControlRoutes from "./quality-control"


export default [
    ...SettingsRoutes,
    ...ProductionRoutes,
    ...IntakeRoutes,
    ...FinanceRoutes,
    ...QualityControlRoutes,
]